import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Polygon from '../Polygon';
import GeometryCollection from '../GeometryCollection';
import ArrayList from '../../../../../java/util/ArrayList';
import GeometryFilter from '../GeometryFilter';
var PolygonExtracter = /*#__PURE__*/function () {
  function PolygonExtracter() {
    _classCallCheck(this, PolygonExtracter);
    PolygonExtracter.constructor_.apply(this, arguments);
  }
  _createClass(PolygonExtracter, [{
    key: "filter",
    value: function filter(geom) {
      if (geom instanceof Polygon) this._comps.add(geom);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryFilter];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._comps = null;
      var comps = arguments[0];
      this._comps = comps;
    }
  }, {
    key: "getPolygons",
    value: function getPolygons() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        return PolygonExtracter.getPolygons(geom, new ArrayList());
      } else if (arguments.length === 2) {
        var _geom = arguments[0],
          list = arguments[1];
        if (_geom instanceof Polygon) list.add(_geom);else if (_geom instanceof GeometryCollection) _geom.apply(new PolygonExtracter(list));
        return list;
      }
    }
  }]);
  return PolygonExtracter;
}();
export { PolygonExtracter as default };